import { store } from '../../redux/store'
import _ from 'lodash/object'

export default (key, defaultValue = '') => {
  const state = store.getState()
  return _.get(state, `App.config.${key}`, defaultValue)
}
